import { InstagramIcon, TwitterIcon } from "components/atoms/Icon";
import { linkShare } from "utils/HelperFunctions";
import { Share } from "@mui/icons-material";
import { LinkIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { ROUTES } from "../../../constants";

type BrandSocial = Pick<
  Brand,
  "id" | "name" | "instagram_link" | "website_link" | "other_link" | "profile_image_url" | "twitter_link"
>;

export default function BrandSocialCard({
  textDark = false,
  name,
  website_link: brandWebsiteLink,
  other_link: otherLink,
  twitter_link: twitterLink,
  instagram_link: instagramLink,
  profile_image_url: brandProfileImage,
}: BrandSocial & { textDark?: boolean }) {
  const socialMediaLinks = [
    { icon: <GlobeAltIcon className="h-3 w-3 md:h-5 md:w-5" />, link: brandWebsiteLink },
    { icon: <TwitterIcon className="h-3 w-3 md:h-5 md:w-5" />, link: twitterLink },
    { icon: <InstagramIcon className="h-3 w-3 md:h-5 md:w-5" />, link: instagramLink },
    { icon: <LinkIcon className="h-3 w-3 text-primary md:h-5 md:w-5" />, link: otherLink },
  ];

  return (
    <div
      className={clsx(
        "mt-4 h-24 w-full rounded border-[0.3px] border-white border-opacity-30 bg-primary p-2 md:mt-0 md:h-52  md:rounded-2xl md:border md:p-4",
        textDark ? "text-primary" : "text-white",
      )}
    >
      <div className="flex h-full items-center">
        <img
          // TODO: Add default Image
          src={brandProfileImage || ""}
          alt="Brand Logo"
          className="mr-2 aspect-1 h-full rounded-sm border-[0.3px] border-white border-opacity-20 object-cover object-center md:mr-5 md:rounded-ll md:border"
        />
        <div className="overflow-hidden">
          <h1 className="line-clamp-2 truncate overflow-ellipsis font-satoshi text-[10px] font-semibold md:text-4xl 2xl:text-5xl">
            {name}
          </h1>
          <div className="mt-4 flex flex-wrap items-center md:space-x-3">
            <Share
              className="mr-2 h-3 w-3 cursor-pointer md:h-5 md:w-5"
              onClick={(e) => {
                linkShare();
                e.stopPropagation();
              }}
            />
            <hr className="mr-2 h-3 w-[0.6px] bg-white md:h-6" />
            {socialMediaLinks.map(
              (social) =>
                // eslint-disable-next-line implicit-arrow-linebreak
                social.link && (
                  <a
                    key={social.link}
                    href={social.link}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {social.icon}
                  </a>
                ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BrandSocialCardNew({
  textDark = false,
  id,
  name,
  website_link: brandWebsiteLink,
  other_link: otherLink,
  twitter_link: twitterLink,
  instagram_link: instagramLink,
  profile_image_url: brandProfileImage,
}: BrandSocial & { textDark?: boolean }) {
  const socialMediaLinks = [
    { icon: <GlobeAltIcon className="h-4 w-4 md:h-5 md:w-5" />, link: brandWebsiteLink },
    { icon: <TwitterIcon className="h-3 w-3 md:h-5 md:w-5" />, link: twitterLink },
    { icon: <InstagramIcon className="h-3 w-3 md:h-5 md:w-5" />, link: instagramLink },
    { icon: <LinkIcon className="h-3 w-3 text-primary md:h-5 md:w-5" />, link: otherLink },
  ];

  return (
    <div
      className={clsx(
        "z-0 -mt-8 flex items-center space-x-2 py-2 font-satoshi md:space-x-0",
        textDark ? "text-primary" : "text-white",
      )}
    >
      <img
        // TODO: Add default Image
        src={brandProfileImage || ""}
        alt="Brand Logo"
        className=" z-10 aspect-1 h-12 rounded-sm border-[0.3px] border-white border-opacity-50  object-cover object-center md:mr-5 md:h-16 lg:h-20 "
      />
      <div className="z-10">
        <Link to={`${ROUTES.BRAND_PUBLIC_PROFILE}/${id}`} className="text-lg font-bold lg:text-2xl">
          {name}
        </Link>
        <div className="mt-1 flex items-center space-x-3">
          {socialMediaLinks.map(
            (social) =>
              // eslint-disable-next-line implicit-arrow-linebreak
              social.link && (
                <a
                  key={social.link}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {social.icon}
                </a>
              ),
          )}
        </div>
      </div>
    </div>
  );
}
